import { AccountUIApiProvider } from '@newfront-insurance/account-ui';
import type { PropsWithChildren, JSX } from 'react';

export function AccountUIProvider({ children }: PropsWithChildren<unknown>): JSX.Element {
  return <AccountUIApiProvider basePath="/api/account-ui">{children}</AccountUIApiProvider>;
}
